import { useMutation } from 'react-query';
import { network } from 'services/network';

const mutationFn = (params: QueryParams) => {
    return network.post('api/bo/narratives/updateTemplateText', params).then((response) => {
        return response.data;
    });
};

export const useMutationUpdateTemplateText = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    componentKey: string;
    componentId: number;
    text: string;
    forCurrentCustomerOnly: boolean;
}
